import React, { useEffect, useState } from "react";
import {
  acceptPractitionerPushPermission,
  declinePractitionerPushPermission,
} from "../services/mobilePush";

export default function PractitionerPushPrompt() {
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener("observer:push-permission-prompt", show);
    return () =>
      window.removeEventListener("observer:push-permission-prompt", show);
  }, []);
  if (!visible) return null;
  const choose = async (enable: boolean) => {
    setBusy(true);
    try {
      if (enable) await acceptPractitionerPushPermission();
      else await declinePractitionerPushPermission();
    } finally {
      setBusy(false);
      setVisible(false);
    }
  };
  return (
    <aside
      role="dialog"
      aria-modal="true"
      aria-label="Practitioner notifications"
      className="ot-push-prompt"
    >
      <h2>Profile updates</h2>
      <p>
        Get neutral, private alerts about reviews, disputes, corrections, and
        claim verification on your claimed profile. Notification previews never
        contain review text, scores, or evidence.
      </p>
      <div>
        <button disabled={busy} onClick={() => void choose(false)}>
          Not now
        </button>
        <button disabled={busy} onClick={() => void choose(true)}>
          Enable notifications
        </button>
      </div>
    </aside>
  );
}
